
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/locale/news/detail",
      function () {
        return require("private-next-pages/locale/news/detail.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/locale/news/detail"])
      });
    }
  